import axios from 'axios';
import { firebaseAuthService } from '../auth/firebaseAuthService';

const api = axios.create({
  baseURL: undefined, // Change to your API base URL
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Set to true if you need to send cookies
});

// Request interceptor to add Firebase ID token
api.interceptors.request.use(
  async (config) => {
    try {
      const firebaseUser = firebaseAuthService.getCurrentUser();
      if (firebaseUser) {
        // Get the Firebase ID token
        const idToken = await firebaseUser.getIdToken();
        if (idToken) {
          config.headers.Authorization = `Bearer ${idToken}`;
          console.log('Firebase ID token added to request');
        }
      }
    } catch (error) {
      console.error('Error getting Firebase ID token:', error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle Firebase token refresh
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Only attempt refresh if it's a 401 error and we haven't already tried
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Get the current Firebase user
        const firebaseUser = firebaseAuthService.getCurrentUser();
        if (firebaseUser) {
          // Force refresh the Firebase ID token
          const newIdToken = await firebaseUser.getIdToken(true);
          
          // Update the authorization header with new token
          originalRequest.headers.Authorization = `Bearer ${newIdToken}`;
          
          // Retry the original request with new token
          return api(originalRequest);
        } else {
          throw new Error('No Firebase user found');
        }
      } catch (refreshError) {
        console.error('Firebase token refresh failed:', refreshError);
        
        // Clear auth data and redirect to login
        localStorage.removeItem('auth_user');
        localStorage.removeItem('auth_tokens');
        
        // Only redirect if we're not already on the login page
        if (window.location.pathname !== '/sign-in') {
          window.location.href = '/sign-in';
        }
        
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
